<template>
  <v-container fluid class="mt-0">
    <v-snackbar
      v-model="snack"
      :timeout="4000"
      top
      :color="snackColor"
      class="text-capitalize"
    >
      {{ snackText }}
      <v-btn @click="snack = false" outlined>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-data-table
      :headers="headers"
      :items="customers"
      :options.sync="options"
      :server-items-length="totalCustomers"
      show-expand
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Customer</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" persistent max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn small dark class="mb-2" v-on="on">
                <v-icon>add</v-icon>
              </v-btn>
            </template>

            <v-app-bar>
              <v-spacer></v-spacer>
              <v-btn @click="close" icon>
                <v-icon large>settings_backup_restore</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="save" :disabled="!valid" icon color="primary">
                <v-icon large>save</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
            </v-app-bar>

            <v-card>
              <v-card-title>
                <span class="headline"
                  >{{ formTitle }} #{{ editedCustomer.ref }}</span
                >
              </v-card-title>
              <v-card-text>
                <v-form wrap ref="customerForm" v-model="valid">
                  <v-container fluid>
                    <v-text-field
                      v-model="editedCustomer.first_name"
                      label="First Name"
                      :rules="rules.name"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedCustomer.last_name"
                      label="Last Name"
                      :rules="rules.name"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedCustomer.email"
                      label="Email"
                      :rules="rules.email"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedCustomer.phone"
                      label="Phone"
                    ></v-text-field>
                    <!-- <v-switch
                      v-model="editedCustomer.active"
                      label="Active"
                      inset
                    ></v-switch>-->

                    <v-select
                      :items="categories"
                      v-model="editedCustomer.categories"
                      :rules="rules.categories"
                      label="Categories"
                      chips
                      multiple
                    ></v-select>
                    <v-select
                      :items="payment"
                      v-model="editedCustomer.payment"
                      :rules="rules.payment"
                      label="Payment"
                    ></v-select>
                    <v-select
                      :items="status"
                      v-model="editedCustomer.status"
                      :rules="rules.status"
                      label="Status"
                    ></v-select>

                    <v-textarea
                      readonly
                      auto-grow
                      rows="2"
                      :value="editedCustomer.location.address"
                      label="Area"
                      clearable
                      clear-icon="close"
                      @click:clear="clearLocation"
                    >
                      <template v-slot:prepend>
                        <LocationPicker
                          :location="editedCustomer.location"
                          @new_location="setLocation"
                        />
                      </template>
                    </v-textarea>

                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model.number="editedCustomer.properties.price"
                          label="Price"
                        ></v-text-field>
                        <v-text-field
                          v-model.number="editedCustomer.properties.living"
                          label="Living Area"
                        ></v-text-field>
                        <v-text-field
                          v-model.number="editedCustomer.properties.bedrooms"
                          label="Bedrooms"
                          type="number"
                        ></v-text-field>
                        <v-text-field
                          v-model.number="editedCustomer.properties.lawn"
                          label="Lawn"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model.number="editedCustomer.properties.property"
                          label="Property Area"
                        ></v-text-field>
                        <v-text-field
                          v-model.number="editedCustomer.properties.bathrooms"
                          label="Bathrooms"
                          type="number"
                        ></v-text-field>

                        <v-text-field
                          v-model.number="editedCustomer.properties.terrace"
                          label="Terrace"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <v-switch
                          label="Pool"
                          v-model="editedCustomer.properties.pool"
                        ></v-switch>

                        <v-switch
                          label="Parking"
                          v-model="editedCustomer.properties.parking"
                        ></v-switch>
                        <v-switch
                          label="Garage"
                          v-model="editedCustomer.properties.garage"
                        ></v-switch>
                        <v-switch
                          label="Rental Licence"
                          v-model="editedCustomer.properties.rental"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <v-switch
                          label="Sea Access"
                          v-model="editedCustomer.properties.sea_access"
                        ></v-switch>
                        <v-switch
                          label="Sea View"
                          v-model="editedCustomer.properties.sea_view"
                        ></v-switch>
                        <v-switch
                          label="Golf"
                          v-model="editedCustomer.properties.golf"
                        ></v-switch>
                        <v-switch
                          label="Investment"
                          v-model="editedCustomer.properties.investment"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-textarea
                      v-model="editedCustomer.info"
                      label="Info"
                      auto-grow
                    />
                    <v-textarea
                      v-model="editedCustomer.comment"
                      label="Comment"
                      auto-grow
                    />
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <v-row>
            <p class="body-1">Email: {{ item.email }}</p>
          </v-row>
          <v-row>
            <p class="body-1">Phone: {{ item.phone }}</p>
          </v-row>
          <v-row>
            <p class="body-1">Area: {{ item.location.address }}</p>
          </v-row>
          <v-row>
            <p class="body-2">Info: {{ item.info }}</p>
          </v-row>
          <v-row>
            <p class="body-2">Comment: {{ item.comment }}</p>
          </v-row>
        </td>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editCustomer(item)">edit</v-icon>
        <v-icon small @click="deleteCustomer(item)">delete</v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { CustomerService } from '@/services/customer.service'
import LocationPicker from '@/components/map/LocationPicker'

const defaultCustomer = {
  categories: ['VILLA'],
  payment: 'BUY',
  status: 'SEARCHING',
  location: {},
  range: 10,
  properties: {}
}

export default {
  name: 'customers',
  components: { LocationPicker },
  data() {
    return {
      customers: [],
      totalCustomers: 0,
      loading: false,
      options: {
        itemsPerPage: -1
      },
      headers: [
        { text: 'Status', value: 'status', align: 'left', sortable: false },
        { text: 'First Name', value: 'first_name', align: 'left' },
        { text: 'Last Name', value: 'last_name', align: 'left' },
        { text: 'Info', value: 'info', align: 'left' },
        { text: 'Actions', value: 'action', sortable: false },
        { text: 'Details', value: 'data-table-expand', sortable: false }
      ],
      dialog: false,
      editedIndex: -1,

      editedCustomer: {
        location: {},
        properties: {}
      },
      valid: true,

      categories: [
        'VILLA',
        'APARTMENT',
        'FINCA',
        'PENTHOUSE',
        'COMMUNITY',
        'BUSINESS',
        'PLOT'
      ],
      status: ['SELLING', 'SEARCHING', 'HAPPY'],
      payment: ['BUY', 'RENT'],
      errors: {},
      snack: false,
      snackColor: '',
      snackText: '',
      rules: {
        categories: [
          v => v.length > 0 || 'Select one or more categories',
          () => !this.errors.categories || this.errors.categories
        ],
        payment: [
          v => !!v || 'Select payment type',
          () => !this.errors.payment || this.errors.payment
        ],
        status: [
          v => !!v || 'Select status type',
          () => !this.errors.status || this.errors.status
        ],
        name: [
          v => !!v || 'Name is required',
          v =>
            (v && v.length <= 100) || 'Name must be less than 100 characters',
          () => !this.errors.name || this.errors.name
        ],
        email: [
          v =>
            !v ||
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            'E-mail must be valid',
          () => !this.errors.email || this.errors.email
        ]
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    options: {
      async handler() {
        const { customers, count } = await this.getCustomers()
        this.customers = customers
        this.totalCustomers = count
      },
      depp: true
      // immediate: true
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Customer' : 'Edit Customer'
    }
  },
  methods: {
    async getCustomers() {
      this.loading = true
      try {
        const { sortBy, descending, page, itemsPerPage } = this.options
        const filter = {
          page: page,
          limit: itemsPerPage === -1 ? 0 : itemsPerPage,
          order: (sortBy ? sortBy : '') + (descending ? ' desc' : '')
        }

        let { customers, count } = await CustomerService.getCustomers(filter)
        // console.table(customers)
        return { customers, count }
      } catch (error) {
        console.log('could not get customers data', error)
      } finally {
        this.loading = false
      }
    },

    editCustomer(customer) {
      this.editedIndex = this.customers.indexOf(customer)
      this.editedCustomer = Object.assign({}, customer)
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.editedIndex = -1
      this.editedCustomer = Object.assign({}, defaultCustomer)
    },

    async save() {
      if (this.editedIndex > -1) {
        try {
          const customer = await CustomerService.updateCustomer(
            this.editedCustomer
          )
          Object.assign(this.customers[this.editedIndex], customer)
          this.close()
          this.snackSuccess('customer updated')
        } catch (error) {
          this.errors = { ...error.fields }
          this.$refs.customerForm.validate()
          this.snackError(error.message)
        }
      } else {
        try {
          const customer = await CustomerService.createCustomer(
            Object.assign({}, this.editedCustomer)
          )
          this.customers.push(customer)
          this.totalCustomers += 1
          this.close()
          this.snackSuccess('customer created')
        } catch (error) {
          this.errors = { ...error.fields }
          this.$refs.customerForm.validate()
          this.snackError(error.message)
        }
      }
    },

    async deleteCustomer(customer) {
      if (
        await this.$root.$confirm('Delete', 'Are you sure?', {
          color: 'error'
        })
      ) {
        try {
          const index = this.customers.indexOf(customer)
          const id = this.customers[index].id
          await CustomerService.deleteCustomer(id)
          this.customers = this.customers.filter(v => v.id !== id)
          this.totalCustomers--
          this.snackSuccess('customer deleted')
        } catch (error) {
          this.snackError('could not delete customer')
        }
      }
    },

    setLocation(loc) {
      this.editedCustomer.location = loc
    },
    clearLocation() {
      this.editedCustomer.location = { address: '', lat: 0, lng: 0 }
    },

    snackSuccess(message) {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = message
    },
    snackError(message) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = message
    }
  },

  mounted() {
    this.editedCustomer = defaultCustomer
  }
}
</script>
